import { KEYS } from '../../constants/SceneConstants';
import GameSceneBase from './GameSceneBase';
import { GameTimer } from '../../display/ui/games/GameTimer';
import { OnboardingPointer } from '../../display/ui/OnboardingPointer';

/*

Game Concept

There are switches hidden by 'sliders'
When the user clicks a 'slider' it tweens to the side, waits a second ( or two - play test it ) then returns back
When the slider uncovers the switch - the user can click the switch to turn it off or on

There are no assets for this yet, use graphics - or feel free to grab some place holder assets and create spritehseets

switches will need two states : on ( default ) / off 
switches will need to look visually different in each state ( red / greed )?

start with 1 switch and slider while you are working out the logic.
Then add 7 more where ever you like within the safe area

There is also an "energy meter" with a 'slot' for each switch
  - an on switch fills 1 bar - so if 4/6 switches are on - then 4/6 bars should be lit up

*/

// TASHII :: Position sliders so that hit areas are over the relevant objects - I have done 'popcorn' as an eexample
// I've commented them out for now for testing, I'd enable one at a time and position
const SLIDERS = [
  {
    spine: { id: 'energy_saver_flowers' },
    hitArea: { x: 480, y: 375, width: 120, height: 168, slide: { x: -65, y: 0 } },
  },
  {
    spine: { id: 'energy_saver_books' },
    hitArea: { x: 635, y: 220, width: 100, height: 120, slide: { x: 70, y: 0 } },
  },
  {
    spine: { id: 'energy_saver_laundry' },
    hitArea: { x: 1065, y: 358, width: 120, height: 90, slide: { x: 40, y: 120 } },
  },
  {
    spine: { id: 'energy_saver_popcorn' },
    // hit area determines default click zone when spine first load, slide is to adjust position when slider moves
    hitArea: { x: 1055, y: 525, width: 80, height: 90, slide: { x: 40, y: 0 } },
  },
  {
    spine: { id: 'energy_saver_spices' },
    hitArea: { x: 980, y: 266, width: 125, height: 85, slide: { x: 45, y: 0 } },
  },
];

// TASHII :: Position sliders so that hit areas are over the relevant objects - I have done 'heater' as an eexample
// I've commented them out for now for testing, I'd enable one at a time and position
const SWITCHES = [
  {
    spine: { id: 'energy_saver_chargers', loop: true },
    hitArea: { x: 600, y: 465, width: 30, height: 50 },
  },
  {
    spine: { id: 'energy_saver_coffee', loop: true },
    hitArea: { x: 535, y: 379, width: 30, height: 50 },
  },
  {
    spine: { id: 'energy_saver_washing_machine', loop: true },
    hitArea: { x: 1070, y: 430, width: 30, height: 40 },
  },
  {
    spine: { id: 'energy_saver_heater', loop: true },
    hitArea: { x: 1060, y: 550, width: 30, height: 60 },
  },
  {
    spine: { id: 'energy_saver_speakers', loop: true },
    hitArea: { x: 655, y: 300, width: 60, height: 30 },
  },
  {
    spine: { id: 'energy_saver_toaster', loop: true },
    hitArea: { x: 1120, y: 360, width: 60, height: 30 },
  },
  {
    spine: { id: 'energy_saver_fan', loop: true },
    hitArea: { x: 990, y: 290, width: 30, height: 60 },
  },
];

const GAME_TIME_LIMIT = 30000;

export default class EnergySaver extends GameSceneBase {
  constructor() {
    super({ key: KEYS.EnergySaver, active: false });
  }

  create() {
    super.create();
    this.gameRunning = false;
    this.timelimit = GAME_TIME_LIMIT;
    //Spines
    this.spineBG = this.add.spine(840, 360, 'energy_saver_background', '', false);

    //Time Display
    this.gameClock = new GameTimer(this, 550, 0);
    this.add.existing(this.gameClock);
    // this.gameClock.setTimePercent(0);
    this.onboardingPointer = new OnboardingPointer(this);

    // this.meter = this.add.renderTexture(700, 130, 500, 50).setOrigin(0, 0.5).fill(0xffff00);
    this.meter = this.add.spine(840, 360, 'energy_saver_power_guage', '', false);
    this.setupGame();
  }

  setupGame() {
    this.gameClock.visible = false;
    this.timelimit = GAME_TIME_LIMIT;
    //Trigger Intro Animations
    this.spineBG.once('complete', this.showInstruction, this);
    this.spineBG.play('intro');
    this.spineBG.on('event', this.handleSpineEvent, this);

    // this.input.enableDebug(graphic);
    this.switches = SWITCHES.map((sw) => {
      const gameSwitch = new GameInteractive(this, sw.spine, sw.hitArea);
      gameSwitch.on('select', this.handleSwitch, this);
      return gameSwitch;
    });

    //Slider Spines
    this.sliders = SLIDERS.map((sl) => {
      const slider = new GameInteractive(this, sl.spine, sl.hitArea);
      slider.on('select', this.handleSlider, this);
      return slider;
    });

    //play intro animations
    this.sliders.forEach((s) => s.play('intro'));
    this.switches.forEach((s) => s.play('intro'));

    this.updateEnergyBar();
  }

  restartGame() {
    this.switches.forEach((i) => i.destroy());
    this.sliders.forEach((i) => i.destroy());

    this.setupGame();
  }

  handleSpineEvent(t, e) {
    if (e.data?.name === 'sfx') {
      switch (e.stringValue) {
        case 'page_open':
          this.game.soundController.playSFX('general', 'general_page_open');
          break;
        case 'page_close':
          this.game.soundController.playSFX('general', 'general_page_close');
          break;
        case 'page_popup':
          this.game.soundController.playSFX('general', 'general_popup');
          break;
      }
    }
  }

  showInstruction() {
    super.showInstruction(this.game.copy.get('EnergySaver_instruction'), this.startGame, this);
  }
  startGame() {
    this.sliders.forEach((s) => {
      s.setObjectState('on');
      s.enable();
    });
    this.switches.forEach((s) => {
      s.setObjectState('on');
      s.enable();
    });
    //Set Base Start
    this.gameClock.visible = true;
    this.gameClock.enter();
    this.meter.play('in');
    this.timelimit = GAME_TIME_LIMIT;

    this.updateOnboardingPositions();
    this.onboardingPointer.enable();
    this.gameClock.once('complete', () => (this.gameRunning = true), this);
    //this.meter.texture.scaleX = this.meter.scaleX;
  }

  updateOnboardingPositions() {
    const sliders = this.sliders.filter((s) => s.objectState === 'on').map((s) => s.center);
    const switches = this.switches
      .filter((s) => {
        if (s.objectState === 'off') return false;
        const hidden = this.sliders.find((sl) => sl.overlapsPoint(s.center));
        return hidden ? false : true;
      })
      .map((s) => s.center);
    this.onboardingPointer.setTapPositions([...sliders, ...switches]);
  }

  handleSlider(gameSlider) {
    gameSlider.toggleObjectState();
    this.game.soundController.playSFX('energysaver', 'energy_move_item');
    this.updateOnboardingPositions();
  }

  handleSwitch(gameSwitch) {
    gameSwitch.toggleObjectState();
    console.log(gameSwitch._objectState);
    this.game.soundController.playSFX(
      'energysaver',
      gameSwitch._objectState === 'on' ? 'energy_item_on' : 'energy_item_off'
    );
    this.updateOnboardingPositions();
    this.updateEnergyBar();
  }

  updateEnergyBar() {
    const onSwitches = this.switches.filter((i) => i.objectState === 'on');
    if (onSwitches.length > 0) {
      this.meter.setSkinByName('power_' + (8 - onSwitches.length));
    } else {
      this.meter.setSkinByName('power_8');
    }

    if (onSwitches.length === 0) this.finishGame();
  }

  update(t, delta) {
    if (!this.gameRunning) return;

    this.timelimit -= delta;
    this.gameClock.setTimePercent(this.timelimit / GAME_TIME_LIMIT);
    if (this.timelimit < 0) this.finishGame();
  }

  finishGame() {
    this.gameRunning = false;
    this.gameClock.exit();
    this.game.soundController.stopAllSFX();
    this.onboardingPointer.disable();
    this.switches.forEach((s) => s.disable());
    this.sliders.forEach((s) => s.disable());
    const onSwitches = this.switches.filter((i) => i.objectState === 'on');
    if (this.timelimit > 0) {
      // we still have time remainin, player one
      const stars = onSwitches.length > 0.5 ? 3 : 2;
      this.closeGame(true, stars);
    } else {
      // no time remains, player lost
      const stars = onSwitches.length < 0.5 ? 1 : 0;
      this.closeGame(false, stars);
    }
  }

  closeGame(didWin, stars) {
    this.game.soundController.stopMusic('music');
    this.spineBG.play(didWin ? 'win' : 'lose');

    this.switches.forEach((s) => s.play(didWin ? 'win' : 'lose'));
    this.sliders.forEach((s) => s.play(didWin ? 'win' : 'lose'));

    this.game.soundController.playSFX('general', didWin ? 'general_success' : 'general_fail', {
      delay: 1.2,
    });
    this.game.soundController.playSFX('energysaver', didWin ? 'energy_success' : 'energy_fail', {
      delay: 2,
    });

    if (!didWin) {
      this.billPile = this.add.spine(840, 360, 'energy_saver_bill_pile', '', false);
      this.billPile.play('lose');
    }

    this.spineBG.once('complete', () => this.showEndGameScreen(didWin, stars));

    this.meter.play('out');
  }

  shutdown() {
    this.game.soundController.stopAllSFX();
    super.shutdown();
    this.game.unloadGame(KEYS.EnergySaver);
  }
}

class GameInteractive extends Phaser.GameObjects.Layer {
  constructor(scene, spine, hitArea) {
    super(scene);
    scene.add.existing(this);
    this._spine = scene.add.spine(840, 360, spine.id);
    this.add(this._spine);
    this._shouldLoop = spine.loop;
    this._hitArea = hitArea;
    this._objectState = 'on';
  }

  get center() {
    return {
      x: this._hitArea.x + this._hitArea.width * 0.5,
      y: this._hitArea.y + this._hitArea.height * 0.5,
    };
  }

  get objectState() {
    return this._objectState;
  }

  play(animation) {
    this._spine.play(animation);
  }

  overlapsPoint({ x, y }) {
    if (!this._interactive) return false;

    if (this._interactive) {
      return (
        x > this._interactive.x &&
        x < this._interactive.x + this._interactive.width &&
        y > this._interactive.y &&
        y < this._interactive.y + this._interactive.height
      );
    }
  }

  toggleObjectState() {
    this.setObjectState(this._objectState === 'on' ? 'off' : 'on');
  }

  setObjectState(state) {
    this._objectState = state;
    this._spine.play(this._objectState, this._shouldLoop);
    if (this._interactive && this._hitArea.slide) {
      if (this._objectState === 'on') {
        this._interactive.x = this._hitArea.x;
        this._interactive.y = this._hitArea.y;
      } else {
        this._interactive.x = this._hitArea.x + this._hitArea.slide.x;
        this._interactive.y = this._hitArea.y + this._hitArea.slide.y;
      }
    }
  }

  enable() {
    if (this._interactive) return;
    this._interactive = this.scene.add
      .zone(this._hitArea.x, this._hitArea.y, this._hitArea.width, this._hitArea.height)
      .setOrigin(0);
    this._interactive.setInteractive({ useHandCursor: true });
    this._interactive.on('pointerdown', () => this.emit('select', this), this);
    this.add(this._interactive);
    if (__WATCH__) this.scene.input.enableDebug(this._interactive);
  }

  disable() {
    if (this._interactive) {
      if (__WATCH__) this.scene.input.removeDebug(this._interactive);
      this._interactive.removeInteractive();
      this._interactive.destroy();
      this._interactive = null;
    }
  }

  destroy() {
    this.disable();
    super.destroy();
  }
}
